<template>
  <v-dialog 
  :value="value" 
  @input="$emit('input')" 
  transition="fade-transition" 
  scrollable 
  width="1000px">
    <v-card>
      <v-card-title class="card-title-background">
        View Travel Form
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="bg-white" style="height: 700px;margin-top:20px;">
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6" v-for="(tallyForm, title) in travelFormData" :key="title" v-if="!excludeTitles.includes(title) && tallyForm !== null">
            <label>{{title}}</label>
            <div v-if="Array.isArray(tallyForm)">
              {{tallyForm.join(', ') || '-'}}
            </div>
            <div v-else>
              {{tallyForm || '-'}}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ViewModalDialog',
  props: {
    value: Boolean,
    travelData: Object
  },
  data () {
    return {
      travelFormData: {},
      influencer: {
        tiktok: {
          tiktokHandle: '',
          tiktokFullname: '',
          totalFollowers: '',
          totalFollowing: ''
        },
        youtube: {
          youtubeHandle: '',
          youtubeFullname: '',
          totalFollowers: '',
          totalFollowing: ''
        },
        instagram: {
          instagramHandle: '',
          instagramFullname: '',
          totalFollowers: '',
          totalFollowing: ''
        }
      },
      excludeTitles: [
        'id',
        'influencerID',
        'Do you have more travel plan?',
        'Do you still have more travel plan?',
        'respondentId',
        'submissionId'
      ]
    }
  },
  watch: {
    travelData: function (newTravelData) {
      this.travelFormData = Object.assign({}, newTravelData)
    }
  },
  mounted() {
    // Retrieve gender config
  },
  methods: {
    close() {
      this.$emit('input');
    }
  }
}
</script>
<style scoped>
  .card-title-background {
    background-color: #3F3FFF;
  }
</style>



// WEBPACK FOOTER //
// ViewModalDialog.vue?4c4603b1